import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d9fbeaa749570014bfdf2f/onthegosafari/src/app/safari-packages-listing/[id]/page.tsx");
